import React, { useState } from "react";
import "../LandingPage/LandingPage.css";
import Footer from "../../Components/Footer/FooterSmall";
import Header2 from "../../Components/Header2/Header2";
import ScheduleForm from "../../Content/Forms/ScheduleForm/ScheduleForm";
import RequestInfoFrom from "../../Content/Forms/RequestInfoForm2/RequestInfoForm";
import "./RequestInfo.css";
import SecHeader from "../../Components/SecHeader/SecHeader";
import { Sun, Moon } from "lucide-react";

const RequestInfo: React.FC = () => {
  const [isLightMode, setIsLightMode] = useState(true);

  return (
    <div className="generalPage">
      <Header2 />
      <div className="pageContainer">
        <div className="request-info-title-container">
          <div className="sectionContainer">
            <SecHeader title="Request Info" iSize={3} />
          </div>
          <div className="request-info-container">
            <div
              className={`request-info-card${isLightMode ? " light-mode" : ""}`}
            >
              {/* <button
                type="button"
                className="theme-toggle-btn"
                onClick={() => setIsLightMode((prev) => !prev)}
                aria-pressed={isLightMode}
              >
                {isLightMode ? <Moon size={16} /> : <Sun size={16} />}
                {isLightMode ? "Dark Mode" : "Light Mode"}
              </button> */}
              <RequestInfoFrom />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RequestInfo;
